export const links = {
  consumate: "https://my.consummatetraders.com/register/a2luZ3Jhc2h5NjQ=",
  ftmo: "https://ftmo.com/",
  kwakol:
    "https://my.kwakolmarkets.com/register?referral=9749fd9d20fee42dc3ccba74365d5818",
  octafx: "https://octafx.page.link/53Pw",
  fbs: "https://fbs.partners?ibl=800742&ibp=29328426",
  exness: "https://one.exness-track.com/a/lex5lmhgps",
};
